import {http} from '../utils'

const terminologySearchAction = (params) => {
  const url = `/chatbi/system/terminology/page/${params.page}/${params.size}?word=${params.word}`
  return http.get(url)
}

const terminologyAddAction = (params) => {
  const url = `/chatbi/system/terminology/add`
  return http.post(url, params)
}

const terminologyDeleteAction = (params) => {
  const url = `/chatbi/system/terminology/delete`
  return http.post(url, params)
}

const terminologyStatusAction = (params) => {
  const url = `/chatbi/system/terminology/${params.id}/enable/${params.enabled}`
  return http.get(url)
}

const sqlExampleSearchAction = (params) => {
  const url = `/chatbi/system/data-training/page/${params.page}/${params.size}?question=${params.question}`
  return http.get(url)
}

const sqlExampleAddAction = (params) => {
  const url = `/chatbi/system/data-training/add`
  return http.post(url, params)
}

const sqlExampleDeleteAction = (params) => {
  const url = `/chatbi/system/data-training/delete`
  return http.post(url, params)
}

const sqlExampleStatusAction = (params) => {
  const url = `/chatbi/system/data-training/${params.id}/enable/${params.enabled}`
  return http.get(url)
}

const getAdvancedApplicationList = () => {
  const url = `/chatbi/system/assistant/advanced_application`
  return http.get(url)
}

const queryAuditSearchAction = (params) => {
  const query = Object.keys(params)
    .filter(key => params[key] !== undefined && params[key] !== null && params[key] !== '')
    .map(key => `${key}=${encodeURIComponent(params[key])}`)
    .join('&')
  return http.get(`/chatbi/system/audit/conversations?${query}`)
}

const queryAuditDetailAction = (chatId) => http.get(`/chatbi/system/audit/conversations/${chatId}`)

export default {
  terminologySearchAction,
  terminologyAddAction,
  terminologyDeleteAction,
  terminologyStatusAction,
  sqlExampleSearchAction,
  sqlExampleAddAction,
  sqlExampleDeleteAction,
  sqlExampleStatusAction,
  getAdvancedApplicationList,
  queryAuditSearchAction,
  queryAuditDetailAction
}
